document.addEventListener('DOMContentLoaded', () => {
  const affinityPortal = document.querySelector('#recharge-customer-portal');
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const anchor = params.get('anchor');
  let scrollComplete = false;

  if (!affinityPortal || !anchor) return;

  const selector = /^[A-Za-z][\w-]*$/.test(anchor) ? `#${anchor}` : anchor;

  const observer = new MutationObserver(() => {
    if (scrollComplete) return;

    let matchingSection;
    try {
      matchingSection = affinityPortal.querySelector(selector);
    } catch {
      scrollComplete = true;
      return;
    }

    if (!matchingSection) return;

    scrollComplete = true;

    setTimeout(() => {
      if (matchingSection.tagName === 'DETAILS') matchingSection.open = true;

      const top = matchingSection.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top, behavior: 'smooth' });
    }, 500);
  });

  observer.observe(affinityPortal, { childList: true, subtree: true });
});
